<template>
  <body class="hold-transition login-page">
  <div class="login-box rg-box m-box">
    <div class="login-logo" >
      <img src="/static/img/crp-images/Logo_RCP_Smart_App.png" class="logo-login-signup">
    </div>
    <!-- /.login-logo -->
    <div class="box login-bbox">
      <div class="box-body register-card-body pd-20">
        <p style="text-align: center;" :hidden="!firstStepText">
          Welcome to the Rubbermaid Commercial Products Smart App Registration page.
        </p>
        <p style="text-align: center;font-size: 13px;" :hidden="!firstStepText">
          Please follow the <span style="font-weight: 700; color: #fecd2f">3 step</span> registration process to complete registration
        </p>

        <p class="finalsteps" style="text-align: center;" :hidden="!thirdStepText">
          Thank You for your registration, one of our team members will review your details and will grant access within <span style="color: #fecd2f">12-24 hours.</span>
        </p>
        <form class="row-rm-padding">
          <div class="row">
            <div class="col-md-12">
              <md-steppers :md-active-step.sync="active" md-linear>
                <md-step id="first" :md-editable="false" md-label="Step" step="5" class="stepper1" :md-done.sync="first" style="">
                  <md-field :class="getValidationClass('title')" class="title">
                    <label class="lable-fileds">Title*</label>
                    <md-select v-model="form.title"  name="title" id="title" placeholder="Title*">
                      <md-option value="Mr.">Mr</md-option>
                      <md-option value="Mrs.">Mrs</md-option>
                      <md-option value="Miss.">Miss</md-option>
                      <md-option value="Other">Other</md-option>
                    </md-select>
<!--                    <span class="md-error" v-if="!$v.form.title.required">The title is required</span>-->
                    <span class="md-error" v-if="this.backendValidationform.title.isError">{{this.backendValidationform.title.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('first_name')">
                    <label class="lable-fileds">First Name*</label>
                    <md-input v-model="form.first_name" name="first_name" id="first_name"  placeholder="First Name*"/>
                    <span class="md-error" v-if="!$v.form.first_name.required">The first name is required</span>
                    <span class="md-error" v-if="$v.form.first_name.required && this.backendValidationform.first_name.isError">{{this.backendValidationform.first_name.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('last_name')">
                    <label class="lable-fileds">Last Name*</label>
                    <md-input v-model="form.last_name" name="last_name" id="last_name"  placeholder="Last Name*"/>
                    <span class="md-error" v-if="!$v.form.last_name.required">The last name is required</span>
                    <span class="md-error" v-if="$v.form.last_name.required && this.backendValidationform.last_name.isError">{{this.backendValidationform.last_name.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('org_name')">
                    <label class="lable-fileds">Organization Name*</label>
                    <md-input v-model="form.org_name" name="org_name" id="org_name"  placeholder="Organization Name*"/>
                    <span class="md-error" v-if="!$v.form.org_name.required">The last name is required</span>
                    <span class="md-error" v-if="$v.form.org_name.required && this.backendValidationform.org_name.isError">{{this.backendValidationform.org_name.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('email')">
                    <label class="lable-fileds">Email*</label>
                    <md-input v-model="form.email" name="email" id="email"  placeholder="Email* (will be used as user name)"/>
                    <span class="md-error" v-if="!$v.form.email.required">The email is required</span>
                    <span class="md-error" v-if="$v.form.email.required && this.backendValidationform.email.isError">{{this.backendValidationform.email.errorMsg}}</span>
                  </md-field>
                  <md-field :class="getValidationClass('phone_no')">
                    <label class="lable-fileds">Phone Number*</label>
                    <md-input v-model="form.phone_no" name="phone_no" id="phone_no"  placeholder="Phone Number*"/>
                    <span class="md-error" v-if="!$v.form.phone_no.required">The phone Number is required</span>
                    <span class="md-error" v-if="$v.form.phone_no.required && this.backendValidationform.phone_no.isError">{{this.backendValidationform.phone_no.errorMsg}}</span>
                  </md-field>
                 
<!-- 
                  <md-field  style="display:none">
                    <label class="lable-fileds">Company / Organization*</label>
                    <md-input v-model="form.organization" name="organization" id="organization" placeholder="Company / Organization*"/>
                  </md-field>
                  <md-field class="industry_id" style="display:none">
                    <label class="lable-fileds">Industry*</label>
                    <md-select v-model="form.industry_id" name="industry_id" id="industry_id" placeholder="Industry*">
                      <md-option v-for="item in industrySelection" v-bind:key="item.id" :value="item.id">
                        {{item.name}}
                      </md-option>
                    </md-select>
                  </md-field>  -->
                  <md-field :class="getValidationClass('state_id')">
                    <label class="lable-fileds">State</label>
                    <md-select v-model="form.state_id" name="state_id" id="state_id">
                      <md-optgroup v-for="item in CountryList" v-bind:key="item.id" :label='item.name'>
                        <md-option v-for="item2 in item.states" v-bind:key="item2.id" :value="item2.id">{{item2.name}}</md-option>
                      </md-optgroup>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.state_id.required">The State is required</span>
                    <span class="md-error" v-if="$v.form.state_id.required && this.backendValidationform.state_id.isError">{{this.backendValidationform.state_id.errorMsg}}</span>
                  </md-field>
                  <!-- <md-field :class="getValidationClass('state_id')" class="state">
                    <label class="lable-fileds">State*</label>
                    <md-select v-model="form.state_id" name="state_id" id="state_id" placeholder="State*">
                      <md-option v-for="item in StateList" v-bind:key="item.id" :value="item.id">
                        {{item.name}}
                      </md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.state_id.required">The state is required</span>
                    <span class="md-error" v-if="$v.form.state_id.required && this.backendValidationform.state_id.isError">{{this.backendValidationform.state_id.errorMsg}}</span>
                  </md-field> -->
                  <div>
                    <button type="button" class="rgbtnn btn btn btn-primary btn-block" :disabled="disableNextButton" @click="validateFirstStep">Next</button>
<!--                    <button type="button" class="rgbtnn btn btn btn-primary btn-block" @click="setDone('first', 'second')">Next</button>-->
                    <!-- <md-button class="rgbtnn md-raised md-primary nextBtn btn-block" </md-button> -->
                    <p class="mb-1 rg-center">
                      <spam>Already have an account?
                        <router-link to="/user/login"  class="btn-signup" style="color: red !important;">Sign in</router-link>
                        here!</spam>
                    </p>
                  </div>
                </md-step>


                <!-- ================ 2nd step ============== -->

                <md-step id="second" :md-editable="false" md-label="Step" :md-error="secondStepError" :md-done.sync="second">
                  <!-- <md-field :class="getValidationClass('country_id')" class="country_id">
                    <label class="lable-fileds">Country*</label>
                    <md-select v-model="form.country_id" name="country_id" id="country_id" placeholder="Country*">
                      <md-option v-for="item in countrySelection" v-bind:key="item.id" :value="item.id">
                        {{item.name}}
                      </md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.country_id.required">The country is required</span>
                    <span class="md-error" v-if="$v.form.country_id.required && this.backendValidationform.country_id.isError">{{this.backendValidationform.country_id.errorMsg}}</span>
                  </md-field> -->
                  
                  <!-- <md-field :class="getValidationClass('distributer')">
                    <label class="lable-fileds">Distributor</label>
                    <md-input v-model="form.distributer" name="distributor" id="distributor"  placeholder="Distributor"/>
                    <span class="md-error" v-if="!$v.form.distributer.required">The distributor is required</span>
                    <span class="md-error" v-if="$v.form.distributer.required && this.backendValidationform.distributer.isError">{{this.backendValidationform.distributer.errorMsg}}</span>
                  </md-field> -->

                  <!-- <md-field :class="getValidationClass('products')" class="products">
                    <label class="lable-fileds">Add RCP products in use</label>
                    <md-select multiple v-model="form.products" name="products" id="products" placeholder="Add RCP Products In Use*" @md-selected="selectAllProducts">
                      <md-option v-for="item in productsSelection" class="item-list-my" v-bind:key="item.id" :value="item.id">
                        {{item.name}}
                      </md-option>
                    </md-select>
                    <span class="md-error" v-if="!$v.form.products.required">The RCP product is required</span>
                    <span class="md-error" v-if="$v.form.products.required && this.backendValidationform.products.isError">{{this.backendValidationform.products.errorMsg}}</span>
                  </md-field> -->

                  <md-field :class="getValidationClass('password')">
                    <label class="lable-fileds">Password*</label>
                    <md-input type="password" v-model="form.password" name="password" id="password"  placeholder="Password*"/>
                    <!-- <span class="md-error" v-if="!$v.form.password.required">The password is required</span> -->
                    <!-- <span class="md-error" v-if="$v.form.password.required && this.backendValidationform.password.isError">{{this.backendValidationform.password.errorMsg}}</!-->
                      <span  :style="$v.form.password.required && this.backendValidationform.password.isError ? 'color:red;' : 'color: gray;'" class="pw-info md-error" >Password must contain at least:
                    6 Characters, 1 Uppercase letter, 1 Lowercase letter, 1 Special Character and 1 number</span>
                  </md-field>
                  <br>
                  <br>
                  <md-field :class="getValidationClass('password_confirmation')" class="password_confirmation">
                    <label class="lable-fileds">Confirm Password*</label>
                    <md-input type="password" v-model="form.password_confirmation" name="password_confirmation" id="password_confirmation"  placeholder="Confirm Password*"/>
                    <span class="md-error" v-if="!$v.form.password_confirmation.required">The confirm password is required</span>
                    <span class="md-error" v-if="$v.form.password_confirmation.required && this.backendValidationform.password_confirmation.isError">{{this.backendValidationform.password_confirmation.errorMsg}}</span>
                  </md-field>
                  <br>
                  <div>
                      <ul class="agry_ul">
                        <li class="agry_li">
                          <md-checkbox
                            class="ul-check md-primary md-size-10 radio-regist"
                            v-model="form.terms_and_condition"
                          >I agree to the</md-checkbox>&nbsp;
                        </li>
                        <li class="agry_li">
                          <router-link
                            :to="{ name: 'Terms'}"
                            class="scnd_lr"
                            style="margin-top:-5px;    font-size: 12px; font-weight: 500;"
                            target="_blank"
                          >Terms & Conditions</router-link>&nbsp;
                        </li>
                        <li class="agry_li">
                         <p style=" font-size: 12px;font-weight: 500;"> of this Application.</p>
                        </li>
                      </ul>
                    </div>
                    <br>
                    <div>
                      <ul class="agry_ul">
                        <li class="agry_li">
                          <md-checkbox class="ul-check md-primary md-size-10 radio-regist" v-model="form.privacy_policy">Any personal information you provide to us when registering to use this application will be collected in accordance with our</md-checkbox>&nbsp;
                        </li>
                        <li class="agry_li" style="margin-top: -7px;">
                          <router-link :to="{ name: 'Privacy'}" class="scnd_lr" style="margin-top:-5px;margin-left: 155px; font-size: 12px; font-weight: 500;" target="_blank">Privacy Policy</router-link>
                        </li>
                        <br>
                      </ul>
                    </div>
                    <br>
                    <br>
                  <md-checkbox v-model="form.marketing_agreement" class="md-primary md-size-10 radio-regist">
                     I wish to receive marketing communications from Newell Australia Pty
                    Limited and I understand I can opt-out of receiving such marketing
                    communications at any time using the unsubscribe facility
                    provided in the marketing communication or by contacting Newell Australia Pty Limited.
                  </md-checkbox>
                  <br>
                  <br>
                  <br>
                  <br>
                  <br>
                  <div style="position: relative;">
                    <button type="button" :disabled="disableRegisterButton" @click="validateSubmission" class="rgbtnn btn btn btn-primary btn-block">Register</button>
                  </div>
                </md-step>


                <!-- ================ 3rd step ============== -->
                <!-- Please check your inbox provided during the sign up process. If you haven’t received an email please check spam/junk mail folder in your mail box.    -->
                <md-step id="third" :md-editable="false" md-label="Step" :md-error="thirdStepError" :md-done.sync="third">
                  <br>
                  <br>
                  <br>
                  <div style="text-align: center"><h3>Thank you for registering!</h3></div>
                  <p style="text-align: center">
                  Our team is currently verifying your details. Your account will be activated within the next 12-24 hours.</p>
                  <p style="text-align: center">
                  We have sent you a confirmation email. If you haven’t received the email, please check your junk folder.
                  </p>
                  <br>
                  <br>
                  <br>
                  <div style="position: relative;">
                    <router-link to="/user/login"  class="rgbtnn btn btn btn-primary btn-block" style="color: #fff !important;">Ok</router-link>
                  </div>
                </md-step>
              </md-steppers>
            </div>
          </div>
        </form>
      </div>
      <!-- /.form-box -->
    </div>
  </div>
  </body>
</template>
<script>
  import api from '../../../api'
  import {required} from 'vuelidate/lib/validators'
  import {validationMixin} from 'vuelidate'
  import $ from 'jquery'
  var SyncLoader = require('vue-spinner/src/SyncLoader')

export default {
    name: 'UserRegistrationView',
    components: {
      'SyncLoader': SyncLoader
    },
    mixins: [validationMixin],
    data: () => ({
      active: 'first',
      first: false,
      second: false,
      third: false,
      CountryList: [],
      secondStepError: null,
      thirdStepError: null,
      firstStepText: true,
      secondStepText: false,
      thirdStepText: false,
      checkCurrentStage: 'first',
      // up
      boolean: true,
      title: null,
      industry: null,
      country: null,
      // productsSelection: [],
      // countrySelection: [],
      StateList: [],
      newModal: false,
      newModalLoading: false,
      form: {
        title: 'Mr.',
        first_name: null,
        last_name: null,
        phone_no: null,
        email: null,
        status: null,
        terms_and_condition: false,
        marketing_agreement: false,
        privacy_policy: false,
        password_confirmation: null,
        password: null,
        state_id: null,
        org_name: null
      },
      disableNextButton: false,
      disableRegisterButton: false,
      backendValidationform: {
        title: {
          isError: false,
          errorMsg: ''
        },
        first_name: {
          isError: false,
          errorMsg: ''
        },
        last_name: {
          isError: false,
          errorMsg: ''
        },
        phone_no: {
          isError: false,
          errorMsg: ''
        },
        email: {
          isError: false,
          errorMsg: ''
        },
        terms_and_condition: {
          isError: false,
          errorMsg: ''
        },
        marketing_agreement: {
          isError: false,
          errorMsg: ''
        },
        privacy_policy: {
          isError: false,
          errorMsg: ''
        },
        password_confirmation: {
          isError: false,
          errorMsg: ''
        },
        password: {
          isError: false,
          errorMsg: ''
        },
        state_id: {
          isError: false,
          errorMsg: ''
        },
        org_name: {
          isError: false,
          errorMsg: ''
        }
      },
      FirstComponentbackendValidationform: {
        title: {
          isError: false,
          errorMsg: ''
        },
        first_name: {
          isError: false,
          errorMsg: ''
        },
        last_name: {
          isError: false,
          errorMsg: ''
        },
        phone_no: {
          isError: false,
          errorMsg: ''
        },
        email: {
          isError: false,
          errorMsg: ''
        }
      }
    }),
    validations: {
      form: {
        title: {
          required
        },
        first_name: {
          required
        },
        last_name: {
          required
        },
        phone_no: {
          required
        },
        email: {
          required
        },
        status: {},
        terms_and_condition: {
          // required
        },
        marketing_agreement: {
          // required
        },
        privacy_policy: {
          // required
        },
        password_confirmation: {
          required
        },
        password: {
          required
        },
        state_id: {
          required
        },
        org_name: {
          required
        }

      }
    },
    methods: {
      getCountryList() {
        api
          .request('get', '/admin/country/select')
          .then(response => {
            this.CountryList = response.data.result
          })
      },
      getStateList() {
        api.request('get', '/admin/state/select')
          .then(response => {
            this.StateList = response.data.result
          })
      },
      setDone (id, index) {
        this[id] = true

        this.secondStepError = null
        if (index === 'second') {

        } else if (index === 'third') {

        }

        if (index) {
          this.active = index
        }
      },
      setError () {
        this.secondStepError = 'This is an error!'
      },
      // up
      clearNewForm() {
        this.$v.$reset()
        this.form.title = 'Mr.'
        this.form.first_name = ''
        this.form.last_name = ''
        this.form.phone_no = ''
        this.form.status = '1'
        this.form.terms_and_condition = false
        this.form.marketing_agreement = false
        this.form.state_id = ''
        this.form.password = null
        this.form.password_confirmation = null
      },
      validateSubmission() {
        this.third = true
        this.firstStepText = false
        this.thirdStepText = true
        this.$v.form.$touch()
        var isValid = true

        if (!this.$v.form.$invalid) {
          if (!this.form.terms_and_condition) {
            isValid = false
            // eslint-disable-next-line no-undef
            Swal.fire({
              title: 'Terms & Conditions',
              icon: 'error',
              html:
                'Please accept Terms & Conditions to continue',
              showCloseButton: false,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Agree!',
              confirmButtonAriaLabel: 'Thumbs up, Agree!',
              cancelButtonText:
                '<i class="fa fa-thumbs-down"></i>',
              cancelButtonAriaLabel: 'Thumbs down'
            }).then((result) => {
              if (result.value) {
                this.form.terms_and_condition = true
              }
            })
          }
          if (!this.form.privacy_policy) {
            isValid = false
            // eslint-disable-next-line no-undef
            Swal.fire({
              title: 'Privacy Policy',
              icon: 'error',
              html:
                'Any personal information you provide to us when registering to use this application will be collected in accordance with our <a href="https://rubbermaidcommercial.com.au/privacy-policy/" class="primary-clr" target="_blank">Privacy Policy</a>',
              showCloseButton: false,
              showCancelButton: true,
              focusConfirm: false,
              confirmButtonText:
                '<i class="fa fa-thumbs-up"></i> Agree!',
              confirmButtonAriaLabel: 'Thumbs up, Agree!',
              cancelButtonText:
                '<i class="fa fa-thumbs-down"></i>',
              cancelButtonAriaLabel: 'Thumbs down'
            }).then((result) => {
              if (result.value) {
                this.form.privacy_policy = true
              }
            })
          }
          // if (!this.form.marketing_agreement) {
          //   isValid = false
          //   // eslint-disable-next-line no-undef
          //   Swal.fire({
          //     title: 'marketing communications ',
          //     icon: 'error',
          //     html:
          //       'I wish to receive marketing communications from Newell Australia Pty\n' +
          //       '                    Limited and I understand I can opt-out of receiving such marketing\n' +
          //       '                    communications at any time using the unsubscribe facility\n' +
          //       '                    provided in the marketing communication or by contacting Newell Australia Pty Limited.',
          //     showCloseButton: false,
          //     showCancelButton: true,
          //     focusConfirm: false,
          //     confirmButtonText:
          //       '<i class="fa fa-thumbs-up"></i> Agree!',
          //     confirmButtonAriaLabel: 'Thumbs up, Agree!',
          //     cancelButtonText:
          //       '<i class="fa fa-thumbs-down"></i>',
          //     cancelButtonAriaLabel: 'Thumbs down'
          //   }).then((result) => {
          //     if (result.value) {
          //       this.form.marketing_agreement = true
          //     }
          //   })
          // }
          if (isValid) {
            this.addNewRecord(this.$v.form.$model)
          }
        }
      },
      addNewRecord(data) {
        this.newModalLoading = true
        // data.status = 1
        var ref = this
        api.request('post', '/customer/register', data)
          .then(response => {
            if (response.status === 200) {
              // this.form = response.data.result
              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.backendValidationform.hasOwnProperty(key.toString())) {
                    ref.backendValidationform[key.toString()].isError = true
                    ref.backendValidationform[key.toString()].errorMsg = valueObj[0]
                    $('#' + key.toString()).parent().addClass('md-invalid')
                    $('.' + key.toString()).addClass('md-invalid')
                  }
                })
              } else if (response.data.result.status === 'success') {
                this.newModalLoading = false
                this.newModal = false
                // eslint-disable-next-line no-undef
                // Swal.fire({
                //   position: 'center',
                //   icon: 'success',
                //   title: response.data.result.status.message || 'You have registered successfully',
                //   showConfirmButton: false,
                //   timer: 2000
                // })
                this.clearNewForm()
                // this.$router.push('/user/login')
                this.setDone('second', 'third')
                $('.md-steppers-navigation').css('display', 'none')
                $('.finalsteps').css('display', 'none')
              } else if (response.data.result.status === 'error') {
                this.newModalLoading = false
                this.newModal = false
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              this.newModalLoading = false
              this.newModal = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.newModalLoading = false
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      getValidationClass(fieldName) {
        const field = this.$v.form[fieldName]
        this.isCompleteFirst()
        this.isCompleteLast()
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      // setCountryDropDownData() {
      //   api.request('get', '/admin/country/select')
      //     .then(response => {
      //       this.countrySelection = response.data.result
      //     })
      // },
      validateFirstStep() {
        this.first = false
        // this.$v.form.$touch()
        this.newModalLoading = true
        var ref = this
        api.request('post', '/customer/register-validation', this.$v.form.$model)
          .then(response => {
            if (response.status === 200) {
              // this.form = response.data.result

              if (response.data.error) {
                $.each(response.data.error, function(key, valueObj) {
                  if (ref.backendValidationform.hasOwnProperty(key.toString())) {
                    ref.backendValidationform[key.toString()].isError = true
                    ref.backendValidationform[key.toString()].errorMsg = valueObj[0]
                    // eslint-disable-next-line no-undef
                    toast.fire({icon: 'error', title: valueObj[0]})
                    $('#' + key.toString()).parent().addClass('md-invalid')
                    $('.' + key.toString()).addClass('md-invalid')
                  }
                })
              } else if (response.data.result.status === 'success') {
                this.newModalLoading = false
                this.newModal = false
                this.first = true
                this.setDone('first', 'second')
              } else if (response.data.result.status === 'error') {
                this.newModalLoading = false
                this.newModal = false
                // eslint-disable-next-line no-undef
                toast.fire({icon: 'error', title: response.data.result.message})
              }
            } else {
              this.newModalLoading = false
              this.newModal = false
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
            this.newModalLoading = false
            this.$store.commit('TOGGLE_LOADING')
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
            this.response = 'Server appears to be offline'
            this.toggleLoading()
          })
      },
      isCompleteFirst () {
        if (this.$v.form['title'].$invalid ||
          this.$v.form['first_name'].$invalid ||
          this.$v.form['last_name'].$invalid ||
          this.$v.form['email'].$invalid ||
          this.$v.form['state_id'].$invalid ||
          this.$v.form['org_name'].$invalid ||
          this.$v.form['phone_no'].$invalid) {
          // alert(this.$v.form['first_name'].$invalid)
          this.disableNextButton = true
          // alert(this.disableNextButton)
        } else {
          this.disableNextButton = false
        }
      },
      isCompleteLast () {
        if (this.$v.form['password'].$invalid ||
          this.$v.form['password_confirmation'].$invalid ||
          !this.form.terms_and_condition ||
          !this.form.privacy_policy) {
          // alert(this.$v.form['first_name'].$invalid)
          this.disableRegisterButton = true
          // alert(this.disableNextButton)
        } else {
          this.disableRegisterButton = false
        }
      },
      selectAllProducts() {
        // console.log(this.form.products)
        // var allSellected = !$('.option-select-all').hasClass('md-selected')
        // if (allSellected) {
        //   // alert(!$('.option-select-all').hasClass('md-selected'))
        //   // $('.item-list-my').click()
        //   $('.item-list-my').each(function () {
        //     var isSelectedItem = !$('.item-list-my').hasClass('md-selected')
        //     if (isSelectedItem) {
        //       $('.item-list-my').click()
        //     }
        //   })
        // }
        // if (this.form.products.length > 0) {

        // var selectedItem
        // for (selectedItem of this.form.products) {
        //   if (selectedItem === 'all') {
        //     $('.item-list-my').click()
        //       // this.form.products = []
        //       // console.log(this.form.products)
        //       // $('.item-list-my').addClass('md-selected')
        //       // $('.item-list-my').each(function () {
        //       //   console.log($('.md-checkbox .md-primary .md-theme-default').addClass('md-checked'))
        //       // })
        //   } else {
        //
        //   }
          // }
        // }
      }
    },
    computed: {
    },
    mounted() {
      // this.setCountryDropDownData()
      // this.setProductDropDownData()
      this.getStateList()
      this.getCountryList()
    }
}
</script>
<style>
  /*.md-stepper-number {*/
  /*  background-color: #a7a4a4 !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// UserRegistrationView.vue?3d461ac2